exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-513fa1b6]{width:100%;max-width:100%;margin-bottom:20px}table[data-v-513fa1b6]{border-collapse:collapse;border-spacing:0}.table-striped>tbody>tr[data-v-513fa1b6]:nth-of-type(odd){background-color:#f9f9f9}.table>tbody>tr>td[data-v-513fa1b6],.table>tbody>tr>th[data-v-513fa1b6],.table>tfoot>tr>td[data-v-513fa1b6],.table>tfoot>tr>th[data-v-513fa1b6],.table>thead>tr>td[data-v-513fa1b6],.table>thead>tr>th[data-v-513fa1b6]{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-513fa1b6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/documents/family_documents.vue
// module id = XIaT
// module chunks = 2